import { render } from "./UserCoinsData.vue?vue&type=template&id=7b95e3d2&scoped=true"
import script from "./UserCoinsData.vue?vue&type=script&lang=js"
export * from "./UserCoinsData.vue?vue&type=script&lang=js"

import "@/styles/profile/users/userCoinsData.scss?vue&type=style&index=0&id=7b95e3d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b95e3d2"]])

export default __exports__